import { ofType } from "redux-observable";
import { from, of } from "rxjs";
import { catchError, mergeMap, switchMap } from "rxjs/operators";
import { GET_PRESIGNED_URL_FAILURE, GET_PRESIGNED_URL_REQUEST } from "../../../actions/types";
import { getPresignedUrl } from "../../../actions";
import { addNotification } from "../../../actions/ui";
import { DEFAULT_NOTIFICATION_CLOSE_TIMEOUT, NotificationTypeEnum } from "../../../actions/ui/types";
export var getPresignedUrlEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe(ofType(GET_PRESIGNED_URL_REQUEST), switchMap(function(action) {
        var _action_payload;
        return from(api.reportsCenterService.generatePresignedUrl((_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : _action_payload.getPresignedUrlInput).pipe(mergeMap(function(response) {
            var _action_payload;
            if ((_action_payload = action.payload) === null || _action_payload === void 0 ? void 0 : _action_payload.triggerDownload) {
                window.open(response === null || response === void 0 ? void 0 : response.presignedUrl, "_blank");
            }
            var _response_presignedUrl;
            return of(getPresignedUrl.success((_response_presignedUrl = response === null || response === void 0 ? void 0 : response.presignedUrl) !== null && _response_presignedUrl !== void 0 ? _response_presignedUrl : []));
        }), catchError(function(err) {
            return of(getPresignedUrl.failure(err), addNotification({
                type: NotificationTypeEnum.ERROR,
                action: GET_PRESIGNED_URL_FAILURE,
                body: "error_messages.default",
                timeout: DEFAULT_NOTIFICATION_CLOSE_TIMEOUT
            }));
        })));
    }));
};
export default getPresignedUrlEpic;

//# sourceMappingURL=index.js.map